import { Invitation, User } from '~/pods/meetings/types';

export function isUser(arg: User | Invitation): arg is User {
  return 'meetingCount' in arg;
}
